import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
export function UrgencySection() {
  const initialTime = 2 * 3600 + 12 * 60 + 18;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev <= 0 ? initialTime : prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [initialTime]);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-black py-4 md:py-12 px-4 font-sans border-t border-gray-800" data-id="element-226">
      <div className="max-w-4xl mx-auto text-center" data-id="element-227">
        <h2 className="text-2xl md:text-4xl font-black text-white uppercase tracking-wide mb-3 md:mb-6" data-id="element-228">
          ESTA OFERTA ESPECIAL TERMINA EN
        </h2>

        {/* Countdown Timer */}
        <div className="flex justify-center items-start gap-2 md:gap-4 mb-4 md:mb-8" data-id="element-229">
          <div className="flex flex-col items-center" data-id="element-230">
            <div className="bg-[#111111] border-2 border-gray-700 rounded-lg w-16 h-20 md:w-28 md:h-32 flex items-center justify-center shadow-[0_0_20px_rgba(0,0,0,0.4)]" data-id="element-231">
              <span className="text-4xl md:text-7xl font-black text-red-500 drop-shadow-[0_0_15px_rgba(239,68,68,0.6)]" data-id="element-232">
                {formatNumber(hours)}
              </span>
            </div>
            <span className="text-gray-400 text-xs md:text-sm font-bold mt-2 tracking-widest uppercase" data-id="element-233">
              Horas
            </span>
          </div>

          <div className="text-4xl md:text-6xl font-black text-red-500 mt-4 md:mt-6 animate-pulse" data-id="element-234">
            :
          </div>

          <div className="flex flex-col items-center" data-id="element-235">
            <div className="bg-[#111111] border-2 border-gray-700 rounded-lg w-16 h-20 md:w-28 md:h-32 flex items-center justify-center shadow-[0_0_20px_rgba(0,0,0,0.4)]" data-id="element-236">
              <span className="text-4xl md:text-7xl font-black text-red-500 drop-shadow-[0_0_15px_rgba(239,68,68,0.6)]" data-id="element-237">
                {formatNumber(minutes)}
              </span>
            </div>
            <span className="text-gray-400 text-xs md:text-sm font-bold mt-2 tracking-widest uppercase" data-id="element-238">
              Minutos
            </span>
          </div>

          <div className="text-4xl md:text-6xl font-black text-red-500 mt-4 md:mt-6 animate-pulse" data-id="element-239">
            :
          </div>

          <div className="flex flex-col items-center" data-id="element-240">
            <div className="bg-[#111111] border-2 border-gray-700 rounded-lg w-16 h-20 md:w-28 md:h-32 flex items-center justify-center shadow-[0_0_20px_rgba(0,0,0,0.4)]" data-id="element-241">
              <span className="text-4xl md:text-7xl font-black text-red-500 drop-shadow-[0_0_15px_rgba(239,68,68,0.6)]" data-id="element-242">
                {formatNumber(seconds)}
              </span>
            </div>
            <span className="text-gray-400 text-xs md:text-sm font-bold mt-2 tracking-widest uppercase" data-id="element-243">
              Segundos
            </span>
          </div>
        </div>

        {/* Urgency Badges */}
        <div className="flex justify-center gap-0 mb-4 md:mb-8" data-id="element-244">
          <div className="bg-[#111111] border border-gray-700 text-gray-300 px-3 py-2 rounded-l-md text-xs md:text-sm font-medium flex items-center gap-1.5 whitespace-nowrap" data-id="element-245">
            <span data-id="element-246">👥</span> Últimos cupos
          </div>
          <div className="bg-[#111111] border-y border-gray-700 text-gray-300 px-3 py-2 text-xs md:text-sm font-medium flex items-center gap-1.5 whitespace-nowrap" data-id="element-247">
            <span data-id="element-248">🚀</span> Oferta de Lanzamiento
          </div>
        </div>

        {/* Progress Bar */}
        <div className="max-w-md mx-auto mb-4 md:mb-8" data-id="element-249">
          <div className="text-gray-300 text-sm font-bold mb-2 tracking-wider" data-id="element-250">
            92% DE CUPOS OCUPADOS
          </div>
          <div className="h-3 w-full bg-[#111111] rounded-full overflow-hidden border border-gray-700" data-id="element-251">
            <div className="h-full bg-red-600 rounded-full" style={{
            width: '92%'
          }} data-id="element-252"></div>
          </div>
        </div>
      </div>
    </section>;
}